import { useEffect, useRef, useState } from 'react';
import EcoVideo from 'eco-design/base/eco-video';
import css from './index.module.scss';
import { useLang } from '@/i18n';

const C: React.FC = () => {
    const { t } = useLang('ats.C');
    const [video, setVideo] = useState(['', '']);
    const infoRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!infoRef.current) return;
        const classArr = ['.label-ani', '.title-ani', '.desc-ani'];
        const ani1 = AniContainer.create({
            triggerElement: infoRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                classArr.forEach((item) => {
                    const dom = infoRef.current?.querySelector(item);
                    if (dom) {
                        dom.classList.add('enter');
                    }
                });
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    classArr.forEach((item) => {
                        const dom = infoRef.current?.querySelector(item);
                        if (dom) {
                            dom.classList.remove('enter');
                        }
                    });
                }
            },
        });
        const ani2 = AniContainer.create({
            triggerElement: '.smart-gateway-B',
            triggerHook: 1,
            offset: '50%',
            onEnter: () => {
                if (!video[0] || !video[1]) {
                    setVideo([
                        'https://websiteoss.ecoflow.com/upload/video/1760432805393/ats.mp4',
                        'https://websiteoss.ecoflow.com/upload/video/1760432866037/ats_m.mp4',
                    ]);
                }
            },
        });
        const ani3 = AniContainer.create({
            triggerElement: `.${css.section} .imgs`,
            triggerHook: 1,
            offset: '30%',
            onEnter: () => {
                const video: HTMLVideoElement | null = document.querySelector(`.${css.section} video`);
                if (video) {
                    video.currentTime = 0;
                    video.play();
                }
            },
        });
        return () => {
            ani1.destroy?.();
            ani2.destroy?.();
            ani3.destroy?.();
        };
    }, []);

    return (
        <>
            <section
                className={`${css.section} smart-gateway-C GtmModuleData-section`}
                id="smart-gateway-C"
                data-section-id={'smart-gateway-C'}
                data-section-title={t('title')}
            >
                <div className="box">
                    <div className="info" ref={infoRef}>
                        <div className="label-ani ani-1">
                            <p className={`label `}>{t('label')}</p>
                        </div>
                        <div className="title-ani ani-2">
                            <p className={`title  `}>{t('title')}</p>
                        </div>
                        <div className="desc-ani ani-3 ">
                            <p className={`desc `}>
                                {t.rich('desc', {
                                    h: (v: string) => <span className="highlight">{v}</span>,
                                })}
                            </p>
                        </div>
                    </div>
                </div>
                <ul className="imgs">
                    <li className="img">{video[0] && video[1] && <EcoVideo pc={video[0]} h5={video[1]} loop aria-label={t('title')} />}</li>
                </ul>
            </section>
        </>
    );
};

export default C;
